type ColumnDef<T> = {
  header: string;
  component: (row: T) => string | JSX.Element;
};

type Props<T> = {
  label: string;
  tableDef: ColumnDef<T>[];
  rows: T[];
};

export default function TabularInputs<T>({ label, tableDef, rows }: Props<T>) {
  return (
    <div className="col-span-full">
      <div className="w-fit">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {label}
        </label>
        <div className="mt-4 flow-root">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead className="bg-gray-50">
                    <tr>
                      {tableDef.map((columnDef, index) => (
                        <th
                          key={index}
                          scope="col"
                          className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 whitespace-nowrap"
                        >
                          {columnDef.header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {rows.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {tableDef.map((columnDef, colIndex) => (
                          <td
                            key={colIndex}
                            className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6"
                          >
                            {columnDef.component(row)}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
